// extracted by mini-css-extract-plugin
module.exports = {"container":"sima_sticker-module--container--1-OaX"};